import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Payments from '../../Common/Payment';

class Payment extends Component {

  render() {
    const { apersonal, quotation } = this.props;

    const quoterData = {
      ProductCode: apersonal.selected === 'gold' ? quotation.productCode : quotation.productCodeOptional,
      Beneficiaries: !apersonal.legalHeir ? apersonal.beneficiaries : [],
      ValidFrom: quotation.validFrom, ValidTo: quotation.validTo,
    };

    return (
      <div>
        <Payments
          currency='USD'
          quoterData={quoterData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    quotation: state.quotation,
    apersonal: state.apersonal,
  };
};

export default connect(mapStateToProps, null)(Payment);